import { useAppContext } from "../context/appContext";

import { Navigate } from "react-router";
import { isViewOnly } from "../utils/permissions";

const ProtectedEditRoute = ({ children }) => {
  const { user } = useAppContext();

  const viewOnly = isViewOnly(user);

  if (!user?.email || viewOnly) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedEditRoute;
